<template>
    <div class="page_d">

        <div class="containers">
            <div class="goods">
                <el-image :src="List.imageUrl" fit="cover" class="goods_img"></el-image>
            </div>
            <div class="text1">{{ List.partName }}</div>
            <div class="text2">{{ $t('message.PN') }}: {{ List.partNo }}</div>
            <div class="text3">{{ $t('message.ShortCode') }}: {{ List.shortCode }}</div>
            <div class="text4">{{ $t('message.Category') }}: {{ List.categoryName }}</div>
        </div>
        <div class="btn_blue" @click="goProductDetails()">{{ $t('message.ProductDetails') }}
        </div>
        <div class="btn_blue" @click="goweb(List.installationManualUrl)" v-if="List.isJumpInstallationUrl == 1">{{
            $t('message.ProductInstructions') }}</div>
        <!-- <div class="btn_blue" @click="getInfo()">{{ $t('message.AntiFakeResult') }}</div> -->

    </div>

</template>

<script>
import { EventBus } from "@/main"
import SvgIcon from "@/components/svgIcon/index.vue"
import "@/components/svgIcon/svg.js" // 批量导入svg文件
export default {

    components: {
        SvgIcon
    },
    name: "index",
    props: {
        msg: String,
    },
    data() {
        return {
            List: '',
            smartCode: '',
            country: '',
        }
    },
    created() {

    },
    mounted() {
        // /?smartCode=104c5e55-967a-432e-ad8f-4a5aac7f5871&country=SG
        if (location.href.indexOf("?") != -1) {
            var arr = location.href.split("?")[1];
            console.log('arr==', arr);
            var arr1 = arr.split("&");
            for (var i = 0; i < arr1.length; i++) {
                if (arr1[i].split("=")[0] == 'smartCode') {
                    if (arr1[i].split("=")[1].split("#")) {
                        this.smartCode = arr1[i].split("=")[1].split("#")[0]
                    } else {
                        this.smartCode = arr1[i].split("=")[1]
                    }
                    // localStorage.setItem("smartCode", this.smartCode);
                }
                if (arr1[i].split("=")[0] == 'smarCode') {
                    if (arr1[i].split("=")[1].split("#")) {
                        this.smartCode = arr1[i].split("=")[1].split("#")[0]
                    } else {
                        this.smartCode = arr1[i].split("=")[1]
                    }
                }
                if (arr1[i].split("=")[0] == 'country') {
                    if (arr1[i].split("=")[1].split("#")) {
                        this.country = arr1[i].split("=")[1].split("#")[0]

                    } else {
                        this.country = arr1[i].split("=")[1]

                    }
                    this.country = this.country.toLowerCase()
                }
            }
            console.log('smartCode==', this.smartCode)
            console.log('landingpage_country==', this.country)
            this.$i18n.locale = this.$i18n.messages[this.country] ? this.country : 'en'
            localStorage.setItem('Smart_country', this.country)
        }
        this.getdistrict_country_list()
    },

    methods: {
        goweb(url) {
            window.open(url, "_blank");
        },
        goceshi() {
            this.$router.push({ name: 'ceshi' }, () => {
                // location.reload();

            });
        },
        getdistrict_country_list() {
            var that = this
            that.$flyNo.request({
                method: 'POST',
                url: that.httpUrl.qr_scan,
                body: {
                    scanCode: that.smartCode,
                    country: that.country,
                }
            }).then(res => {
                if (!res) return false
                console.log('--------------——', that.httpUrl.district_country_list, '_res==', res)
                that.List = res.resultData


            })
        },
        goProductDetails() {
            var that = this
            that.$router.push({
                name: 'product_detail', query: {
                    scanCode: that.smartCode,
                    productNumber: that.List.productNumber || that.List.partNo || ''
                }
            });
        },
        getInfo(scanCode) {
            var that = this
            that.$router.push({
                name: 'result_smart', query: {
                    scanCode: that.smartCode
                }
            });

        },
    }
}
</script>


<style lang="scss" scoped>
.btn_blue {
    margin-bottom: 15px;
}

.text1 {
    font-size: 20px;
    line-height: 25px;
    margin-bottom: 16px;
    margin-top: 15px;
    font-weight: bold;

}

.text2 {
    font-size: 16px;
    line-height: 15px;

}

.text3 {
    font-size: 13px;
    font-weight: 400;
    line-height: 15px;
    margin-top: 21px;

}

.text4 {
    font-size: 13px;
    font-weight: 400;
    line-height: 15px;
    margin-top: 7px;

}

.containers {
    min-height: 300px;
    padding: 16px 16px 24px 16px;
    margin: 18px 18px 24px 18px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px 1px 16px 0px #E7F1FD;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #000000;
}

.goods {
    box-sizing: border-box;
    border: 1px solid #E8E8E8;
    border-radius: 5px;
    // padding: 38px;
}

.goods_img {
    width: 100%;
    height: 100%;
}
</style>